import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=0799b78a&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0799b78a')) {
      api.createRecord('0799b78a', component.options)
    } else {
      api.reload('0799b78a', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=0799b78a&", function () {
      api.rerender('0799b78a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Zea4E1k6xWmL/JS/pricehelp.vue"
export default component.exports